import { render, staticRenderFns } from "./secKill.vue?vue&type=template&id=b878c2fc&scoped=true"
import script from "./secKill.vue?vue&type=script&lang=js"
export * from "./secKill.vue?vue&type=script&lang=js"
import style0 from "./secKill.vue?vue&type=style&index=0&id=b878c2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b878c2fc",
  null
  
)

component.options.__file = "secKill.vue"
export default component.exports